import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import Icon from "./Icon";

const ToastContext = createContext(null);

/** const toast = useToast(); toast("Saved"); toast("Oops", "alert"); (icon name optional) */
export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within a ToastProvider");
  return ctx;
}

export function ToastProvider({ children }) {
  const [t, setT] = useState(null);
  const timer = useRef(null);

  const toast = useCallback((msg, icon = "check") => {
    clearTimeout(timer.current);
    setT({ msg, icon, key: Date.now() });
    timer.current = setTimeout(() => setT(null), 2600);
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      {t && (
        <div className="toast" role="status" aria-live="polite" key={t.key}>
          <Icon name={t.icon} size={16} />
          {t.msg}
        </div>
      )}
    </ToastContext.Provider>
  );
}
